import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';

// Determine if we're running on localhost
const isLocalhost = window.location.hostname === 'localhost' ||
                    window.location.hostname === '127.0.0.1' ||
                    window.location.hostname.startsWith('192.168.') ||
                    window.location.hostname.includes('.local');

const environment = isLocalhost ? 'development' : (process.env.REACT_APP_ENVIRONMENT || process.env.NODE_ENV || 'production');

// Only initialize Datadog in production (not on localhost)
if (!isLocalhost) {
  // Initialize Datadog RUM with session recording
  datadogRum.init({
    applicationId: 'be2d5eb8-5f80-43cc-a9d0-8ec9ae1d051f',
    clientToken: 'pub587efca60c861937d49ac52eeff9b310',
    site: 'datadoghq.com',
    service: 'fastmath-fe',
    env: environment,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'allow',
    // Don't record on admin pages
    beforeSend: (event) => {
      if (window.location.pathname.startsWith('/admin')) {
        return false;
      }
      // Drop RUM's auto-captured XHR network errors —
      // our axios interceptor already logs these as warnings with richer context
      if (event.type === 'error' && event.error?.source === 'network') {
        return false;
      }
      return true;
    },
  });

  // Initialize Datadog Logs for browser log forwarding
  datadogLogs.init({
    clientToken: 'pub587efca60c861937d49ac52eeff9b310',
    site: 'datadoghq.com',
    service: 'fastmath-fe',
    env: environment,
    forwardErrorsToLogs: true,
    forwardConsoleLogs: ['error', 'warn'],
    sessionSampleRate: 100,
  });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 